/**
 * @file Web Galleries Blog View.
 */

import React, { Fragment } from 'react';
import Helmet from 'react-helmet';

import WebGalleryHeaderContainer from '../containers/WebGalleryHeaderContainer';
import WebGalleryBlogListingContainer from '../containers/WebGalleryBlogListingContainer';

const WebGalleryBlogListingView = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Blog &ndash; Waldo</title>
      </Helmet>

      <WebGalleryHeaderContainer />
      <div className="flex-auto content-wrap-gray">
        <WebGalleryBlogListingContainer />
      </div>
    </Fragment>
  );
};

export default WebGalleryBlogListingView;
